import React from "react";
import PropTypes from "prop-types";

import Columns from "../../containers/Columns";

export default function VideoRecs({ children }) {
  return (
    <Columns title="You might like..." cols={4} bgColor="bg-gray-800">
      {children}
    </Columns>
  );
}

VideoRecs.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
